export default __webpack_public_path__ + "static/media/info-card-img2.dde0da0e.png";